export const convertItemsForSelect = (obj) => {
  const items = Object.entries(obj).map(([id, label]) => ({
    id,
    label,
  }));
  return items;
};
